import React, { useState } from 'react';
import ArticleCard from '../ArticleCard/ArticleCard';
import Button from '../UI/Button/Button';
import { Grid, GridItem, GridReveal } from '../UI/Grid/Grid';
import { AnimatePresence, motion } from '../UI/framer-motion-custom';
import * as styles from './ArticleListing.module.scss';
import useChunked from '../../hooks/useChunked';

const ArticleListing = ({
  nodes,
  card: Card = ArticleCard,
  isList = false,
  chunkSize = 8,
  isChunked = false,
  cols = { md: 4, lg: 3 },
}) => {
  const [ pageIndex, setPage ] = useState(0);
  const { currentNodes, hasMore } = useChunked(nodes, { pageIndex, chunkSize, isChunked });

  function handleLoadMoreClick() {
    if (hasMore) {
      setPage(pageIndex + 1);
    }
  }

  return (
    <>
      <GridReveal className={styles.grid} isBordered={isList}>
        <AnimatePresence>
          {currentNodes?.map(({ id, article, ...other }) => (
            <GridItem
              as={motion.div}
              layout={true}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              {...(isList ? {} : { ...cols })}
              key={id}
            >
              <Card {...other} {...article} isHorizontal={isList} />
            </GridItem>
          ))}
        </AnimatePresence>
      </GridReveal>

      {isChunked && hasMore && (
        <Grid className={styles.button} justify="center">
          <GridItem md={3}>
            <Button isBlock hideIcon onClick={handleLoadMoreClick}>
              Load more
            </Button>
          </GridItem>
        </Grid>
      )}
    </>
  );
};

export default ArticleListing;
